// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"82":"f3c8b708","247":"59b559ac","256":"57b95ef9","284":"4094ce44","344":"32430517","422":"e1d68f51","440":"681bfa36","627":"dd1bd2f6","834":"fc624468","867":"5659d55b","923":"8fff8dfd","938":"395600d0"}[chunkId] + ".chunk.js";
};